import Phaser from "phaser";
import SceneKeys from "~/consts/SceneKeys";
import TextureKeys from "~/consts/TextureKeys";
import BallKeys from "~/consts/BallKeys";
import { GlobalConfig } from "~/config/GlobalConfig";
import RexUIPlugin from 'phaser3-rex-plugins/templates/ui/ui-plugin'
import IconKey from "~/consts/IconKey";

export default class Preloader extends Phaser.Scene
{
    constructor()
    {
        super(SceneKeys.Preloader)
    }


    preload()
    {

        
        this.load.image(TextureKeys.BG, 'newui/bg-bubble.png');
        
        const bg=this.add.image(0,0,TextureKeys.BG).setOrigin(0,0)
        this.load.on('complete', () => {
            bg.destroy();
        });


        this.load.atlas(TextureKeys.Flare, 'https://labs.phaser.io/assets/particles/flares.png', 'https://labs.phaser.io/assets/particles/flares.json');
        
        this.load.atlas(TextureKeys.Cards, 'cards/cards.png', 'cards/cards.json');
        this.load.atlas(TextureKeys.Avatar, 'assets/avatar.png', 'assets/avatar.json');
        this.load.image(IconKey.home, 'assets/home.png');
        this.load.image(IconKey.add,"assets/add.png");
        this.load.image(IconKey.minus,"assets/minus.png");
        this.load.image(TextureKeys.AI1,"assets/ai1.png");
        this.load.image(TextureKeys.AI1BG,"newui/Geoff.png");
        this.load.image(TextureKeys.AI2BG,"newui/Jim.png");
        this.load.image(TextureKeys.AI3BG,"newui/Kate.png");
        this.load.image(TextureKeys.AI2,"assets/ai2.png");
        this.load.image(TextureKeys.AI3,"assets/ai3.png");
        this.load.image(TextureKeys.CardBG,"assets/card_back.png");
        this.load.image(TextureKeys.GreenBtn,"assets/greenbtn.png");
        this.load.image(TextureKeys.RedBtn,"assets/redbtn.png");


        this.load.image(TextureKeys.BetxBtn1to50, 'newui/1-50Btn.png');
        this.load.image(TextureKeys.AutoPlay, 'newui/autoplay.png');
        this.load.image(TextureKeys.BetHold, 'newui/betx-Con.png');
        this.load.image(TextureKeys.BGOver, 'newui/bg-over.png');
        this.load.image(TextureKeys.RoundRec, 'newui/center-rec.png');
        this.load.image(TextureKeys.FakeDone, 'newui/fake-done.png');
        this.load.image(TextureKeys.FakeNor, 'newui/fake-nor.png');
        this.load.image(TextureKeys.HomeBtn, 'newui/home-btn.png');
        this.load.image(TextureKeys.Left, 'newui/left.png');
        this.load.image(TextureKeys.Logo, 'newui/logo.png');
        this.load.image(TextureKeys.Minus, 'newui/minus.png');
        this.load.image(TextureKeys.Plus, 'newui/plus.png');
        this.load.image(TextureKeys.Right, 'newui/right.png');
        this.load.image(TextureKeys.SimplePlay, 'newui/single-play.png');
        this.load.image(TextureKeys.CloseRanking, 'newui/close.png');
        this.load.image(TextureKeys.Ranking, 'newui/rankhand.png');
        this.load.image(TextureKeys.Info, 'newui/info.png');
        this.load.image(TextureKeys.BoardCardBG, 'newui/cardbg.png');
        this.load.image(TextureKeys.PlayAgin, 'newui/playagain.png');
        this.load.image(TextureKeys.AutoPlayU, 'newui/autoplayun.png');
        this.load.image('Geoff', 'newui/Geoff.png');
        this.load.image('Jim', 'newui/Jim.png');
        this.load.image('Kate', 'newui/Kate.png');


    }

    create()
    {
        this.game.canvas.style.backgroundColor = '#3498db'; 
        this.game.canvas.style.backgroundColor = '#3498db';

        this.cameras.main.setBackgroundColor(0x3498db);
        this.scene.start(SceneKeys.UIScene)
        // this.scene.start(SceneKeys.PokerScene)
    }
}